module.exports = __webpack_public_path__ + "img/0802040.png";